import Config from '../../utils/Configuration';
import {
    UPDATE_TRENDING_SEARCH,
    UPDATE_SEARCH_PROMOTIONS,
    UPDATE_SEARCH_QUERY,
    UPDATE_LAST_SEARCH,
    UPDATE_SELECTED_CATEGORY,
    UPDATE_COMMERCE_SEARCH_SUGGESTIONS
} from '../actions/ActionTypes';
// import {sectionCategories} from '../../components/SearchResults/SearchResults.Config';

const init = () => {
    if (sessionStorage.getItem(Config.sliceKey.searchInfo)) {
        return {...JSON.parse(sessionStorage.getItem(Config.sliceKey.searchInfo))};
    }
    return {
        searchQuery: '',
        // selectedCategory: sectionCategories.all,
        trendingSearches: [],
        searchPromotions: [],
        lastSearch: ''
    };
};

const setSearchQuery = (state, payload = '') => {
    const updatedState = {
        ...state,
        searchQuery: payload
    };
    sessionStorage.setItem(Config.sliceKey.searchInfo, JSON.stringify(updatedState));
    return updatedState;
};

const setSelectedCategory = (state, payload = '') => {
    const updatedState = {
        ...state,
        selectedCategory: payload
    };
    sessionStorage.setItem(Config.sliceKey.searchInfo, JSON.stringify(updatedState));
    return updatedState;
};

const setTrendingSearches = (state, payload = []) => {
    const updatedState = {
        ...state,
        trendingSearches: payload
    };
    sessionStorage.setItem(Config.sliceKey.searchInfo, JSON.stringify(updatedState));
    return updatedState;
};

const setSearchPromotions = (state, payload = []) => {
    const updatedState = {
        ...state,
        searchPromotions: payload
    };
    sessionStorage.setItem(Config.sliceKey.searchInfo, JSON.stringify(updatedState));
    return updatedState;
};

const updateLastSearchStr = (state, payload = '') => {
    const updatedState = {
        ...state,
        lastSearch: payload
    };
    sessionStorage.setItem(Config.sliceKey.searchInfo, JSON.stringify(updatedState));
    return updatedState;
};

const setCommerceSearchSuggestion = (state, payload = '') => {
    return {
        ...state,
        commerceSearchSuggestions: payload
    };
};

const reducer = (state = init(), action) => {
    const {payload} = action;
    switch (action.type) {
        case UPDATE_SEARCH_QUERY:
            return setSearchQuery(state, payload);
        case UPDATE_TRENDING_SEARCH:
            return setTrendingSearches(state, payload);
        case UPDATE_SEARCH_PROMOTIONS:
            return setSearchPromotions(state, payload);
        case UPDATE_LAST_SEARCH:
            return updateLastSearchStr(state, payload);
        case UPDATE_SELECTED_CATEGORY:
            return setSelectedCategory(state, payload);
        case UPDATE_COMMERCE_SEARCH_SUGGESTIONS:
            return setCommerceSearchSuggestion(state, payload);
        default:
            return state;
    }
};

export default reducer;
